export const language: any = {
  title: '식재료',
  select_all: '전체선택',
  deselect_all: '모두 선택 해제',
  add: '재료 추가하기',
  add_title: '재료 추가할 방법을 선택해주세요.',
  add_by_list: '직접 추가',
  add_total: '총 {number}개 재료 추가하기',
  selecting: '총 재료',
  filter_title: '정렬 선택',
  filter_newest: '최신순',
  filter_oldest: '오래된순',
  filter_alphabet: '가나다순',
  get_recipe: 'AI 요리 추천받기',
  search_placeholder: '검색어를 입력해주세요.',
  nodata: '재료가 없습니다.',
  request: '재료 추가하기',
  recipe_title: '추천 요리',
  option: {
    title: '옵션 선택',
    desc: '옵션 선택은 필수가 아닙니다.',
    complete: '완료',
    reset: '초기화',
  },
  msg: {
    msg_7: "선택한 재료를 추가 하시겠습니까?",
    msg_8: `
      <p>선택한 재료를 추가 하시겠습니까?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span>는 기존 식재료에 포함되어 있어 제외됩니다.)</p>
    `,
    msg_9: "선택한 재료를 장바구니에 추가 하시겠습니까?",
    msg_10: `
      <p>선택한 재료를 장바구니에 추가 하시겠습니까?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span>는 기존 식재료에 포함되어 있어 제외됩니다.)</p>
    `,
    confirm: '재료 추가',
    cancel: '취소',
    not_ingredient: '입력하신 내용은 식재료가 아닌 것 같습니다.<br />다시 확인해 주세요.',
    ai_failed: '식재료 입력 시 오류가 발생했습니다.<br />다시 시도해 주세요.',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span>는 기존 식재료에 포함되어 있어 제외됩니다.)`
  },
  history: '이미지 분석 내역',
  myIngredient: "나의 식재료",
  history_no_data: "이력이 없습니다.",
  history_take_photo: "사진 촬영 또는 선택하기",
}
